var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"turnstileEl"}),(_setup.captchaError)?_c('p',{staticClass:"text-danger mt-1",attrs:{"role":"alert"}},[_c('small',[_vm._v(_vm._s(_setup.captchaError))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }